var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6345 10.0432C12.6345 11.4982 11.4545 12.6774 9.99952 12.6774C8.54452 12.6774 7.36536 11.4982 7.36536 10.0432C7.36536 8.58737 8.54452 7.4082 9.99952 7.4082C11.4545 7.4082 12.6345 8.58737 12.6345 10.0432Z",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99829 16.129C13.1716 16.129 16.0741 13.8473 17.7083 10.044C16.0741 6.24065 13.1716 3.95898 9.99829 3.95898H10.0016C6.82829 3.95898 3.92579 6.24065 2.29163 10.044C3.92579 13.8473 6.82829 16.129 10.0016 16.129H9.99829Z",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowIcon1);
export default __webpack_public_path__ + "static/media/show-icon-1.d3929819c877408b361bb2c5b4849f52.svg";
export { ForwardRef as ReactComponent };